<template>
  <!-- 系统维护提示条 -->
  <div v-if="maintenanceInfo.isMaintenance" class="maintenance-notice">
    <div class="maintenance-notice-wrapper">
      <div class="maintenance-notice-content">
        <el-icon class="notice-icon"><Warning /></el-icon>
        <span class="notice-text">系统正在维护中</span>
        <span class="notice-separator">|</span>
        <span class="notice-message">{{
          maintenanceInfo.message || "系统正在维护升级，请稍后再试"
        }}</span>
        <template v-if="maintenanceInfo.startTime || maintenanceInfo.endTime">
          <span class="notice-separator">|</span>
          <span v-if="maintenanceInfo.startTime" class="notice-time">
            维护开始时间：{{ formatTime(maintenanceInfo.startTime) }}
          </span>
          <span
            v-if="maintenanceInfo.startTime && maintenanceInfo.endTime"
            class="notice-separator"
            >-</span
          >
          <span v-if="maintenanceInfo.endTime" class="notice-time">
            预计结束时间：{{ formatTime(maintenanceInfo.endTime) }}
          </span>
        </template>
      </div>
      <!-- 第二份文字，首尾相接 -->
      <div class="maintenance-notice-content maintenance-notice-content-second">
        <el-icon class="notice-icon"><Warning /></el-icon>
        <span class="notice-text">系统正在维护中</span>
        <span class="notice-separator">|</span>
        <span class="notice-message">{{
          maintenanceInfo.message || "系统正在维护升级，请稍后再试"
        }}</span>
        <template v-if="maintenanceInfo.startTime || maintenanceInfo.endTime">
          <span class="notice-separator">|</span>
          <span v-if="maintenanceInfo.startTime" class="notice-time">
            维护开始时间：{{ formatTime(maintenanceInfo.startTime) }}
          </span>
          <span
            v-if="maintenanceInfo.startTime && maintenanceInfo.endTime"
            class="notice-separator"
            >-</span
          >
          <span v-if="maintenanceInfo.endTime" class="notice-time">
            预计结束时间：{{ formatTime(maintenanceInfo.endTime) }}
          </span>
        </template>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useStore } from "vuex";
import { Warning } from "@element-plus/icons-vue";
import dayjs from "dayjs";

const store = useStore();

// 从 store 中获取维护信息
const maintenanceInfo = computed(() => {
  return (
    store.getters["maintenance/maintenanceInfo"] || {
      isMaintenance: false,
      message: "",
      startTime: "",
      endTime: "",
    }
  );
});

// 格式化时间
const formatTime = (time: string) => {
  if (!time) return "";
  return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
};
</script>

<style lang="scss" scoped>
/* 系统维护提示条 */
.maintenance-notice {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(90deg, #ff6b6b 0%, #ee5a6f 100%);
  color: #fff;
  z-index: 10000;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.maintenance-notice-wrapper {
  display: flex;
  width: fit-content;
  animation: scroll 50s linear infinite;
  will-change: transform;
}

.maintenance-notice-wrapper:hover {
  animation-play-state: paused;
}

.maintenance-notice-content {
  display: flex;
  align-items: center;
  padding: 12px 0;
  white-space: nowrap;
  flex-shrink: 0;
}

.maintenance-notice-content-second {
  margin-left: 200px;
}

.notice-icon {
  margin: 0 12px;
  font-size: 18px;
  animation: pulse 2s ease-in-out infinite;
}

.notice-text {
  font-weight: 600;
  font-size: 14px;
  margin-right: 12px;
}

.notice-message {
  font-size: 14px;
  margin: 0 12px;
}

.notice-separator {
  margin: 0 8px;
  opacity: 0.7;
}

.notice-time {
  font-size: 13px;
  opacity: 0.9;
}

@keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(calc(-100% / 2));
  }
}

@keyframes pulse {
  0%,
  100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
</style>
